<template>
  <vs-row vs-justify="center" id="customers-box">
    <vs-col
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-xs="12"
    >
      <vs-card>
        <vs-row class="w-25">
          <vs-col vs-w="10"></vs-col>

          <vs-col vs-w="2">
            <vs-button
                id="add-service-form"
                class="mr-2 w-100"
                icon="add"
                color="primary"
                @click="open()"
            >{{ $t("NoteTypes.Add") }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-card>
      <vs-card>
        <vs-table
            :sst="true"
            :data="noteTypes"
        >
          <template>
            <vs-th>{{
                $t("NoteTypes.Table.Id")
              }}</vs-th>
            <vs-th >{{
                $t("NoteTypes.Table.Title")
              }}</vs-th>
            <vs-th>{{
                $t("NoteTypes.Table.Options")
              }}</vs-th>
          </template>

          <template>
            <vs-tr :key="index" v-for="(noteType, index) in noteTypes">
              <vs-td>
                <div class="d-flex  align-items-center">
                  <div class>
                    <h5 class="mb-0 font-16">
                      {{ index+1 }}
                    </h5>
                  </div>
                </div>
              </vs-td>

              <vs-td>
                <div class="d-flex align-items-center">
                  {{ noteType.title }}
                </div>
              </vs-td>

              <vs-td>
                <div class="btn-alignment">
                  <vs-button
                      id="edit-reseller-button"
                      radius
                      color="warning"
                      type="border"
                      icon="edit"
                      @click="openEdit(noteType)"
                  ></vs-button>
                  <vs-button
                      radius
                      color="danger"
                      type="border"
                      @click="deleteNoteType(noteType)"
                      icon="delete"
                  ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <!-- APPROVED CUSTOMERS TAB -->

      </vs-card>
    </vs-col>

    <Transition>
      <NoteTypeForm v-if="showSideBar" @close="close" @created="addNoteType" @updated="updateNoteType" :showForm.sync="showSideBar" :title="popupTitle" :nt="selectedNoteType"></NoteTypeForm>
    </Transition>
  </vs-row>
</template>

<script>
// moment

import {noteTypeService} from "@/_services";
import NoteTypeForm from "@/components/settings/NoteTypeForm.vue";

export default {
  name: "NoteType",
  data: () => ({
    noteTypes: [],
    showForm: false,
    selectedNoteType:null,
    popupTitle:'',
    showSideBar:false,
  }),
  methods: {
    addNoteType(noteType) {
      this.noteTypes.push(noteType);
      setTimeout(()=>{
        this.showSideBar = false;
      },10);
    },
    updateNoteType(noteType) {
      this.noteTypes.forEach((note) => {
        if(note.id === noteType.id) {
          this.noteTypes[this.noteTypes.indexOf(note)] = noteType;
        }
      })
      setTimeout(()=>{
        this.showSideBar = false;
      },10);
    },
    openEdit(noteType) {
      this.selectedNoteType = {...noteType};
      this.popupTitle = this.$t('NoteTypes.Update')+" "+this.$t('NoteTypes.Title')
      setTimeout(()=>{
        this.showSideBar = true;
      },10);
    },
    deleteNoteType(noteType) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Alert",
        text: this.$t("NoteTypes.DeletePrompt").replace("{name}", noteType.title),
        acceptText: this.$t("Toasts.AcceptButton"),
        cancelText: this.$t("Toasts.CancelButton"),
        accept: ()=> {
          this.showLoading();
          noteTypeService
              .deleteType(noteType.id)
              .then(()=>{
                this.hideLoading();
                this.noteTypes.splice(this.noteTypes.indexOf(noteType), 1);
                this.notify(
                    this.$t("Toasts.Successful"),
                    this.$t("NoteTypes.SuccessDelete"),
                    "success"
                );
              })
              .catch((err)=>{
                console.log(err)
                this.notify(
                    "Error",
                    "Unkown error",
                    "danger"
                );
              })
        }
      });
    },
    close() {
      this.showSideBar = false;
    },
    open() {
      this.popupTitle = this.$t("NoteTypes.Add")
      this.selectedNoteType = null;
      setTimeout(()=>{
        this.showSideBar = true;
      },10);
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text
      });
    },
    showLoading() {
      this.$vs.loading({
        container: "#customers-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#customers-box > .con-vs-loading");
    },
  },
  components: {
    NoteTypeForm
  },
  mounted() {
    this.popupTitle = this.$t("NoteTypes.Add")
    this.showLoading();
    noteTypeService.getAll().then((data)=> {
      this.noteTypes = data.types;
    }).catch((err)=> {
      this.notify(
          "Error",
          "Error loading note types",
          "danger")
    }).finally(()=> {
      this.hideLoading();
    })

  },
};
</script>
<style scoped>
.v-enter-active,
.v-leave-active {
  transition: 0.4s;
}
.v-enter-from {
  transform: translate(100%, 0);
}
.v-leave-to {
  transform: translateX(100%);
}

</style>